import * as THREE from 'three';
import { G, mesh } from '../render/scene';
import { MAT_P, coreGlow } from '../render/materials';
import { bevel, joint, mark, plate, ram, rib, seam } from './mech-kit';
import { TSTANCE } from './titan-pose';
/* ============================================================
   TITAN-3 · 推進器 THRUSTER：骨盆 + 短粗正關節腿 + 背部彈艙
   ============================================================

   腿的三段紡錘與 LANCER-2 同一個作法（上段接髖、中段最鼓、下段收進膝），
   差別是**比例更極端**：大腿寬 0.78（LANCER-2 是 0.62），但骨段長度反而
   更短（0.72 / 0.70，它是 0.80 / 0.74）。粗且短 = 蹲得住。

   腳掌是這台唯一「往前長」的部件：寬 0.94、長 1.06、前後各一塊抓地爪。
   重砲機體開火時的後座要有地方去 —— 剪影上讀得到「釘在地上」。 */

function stompLeg(side, cfg) {
  var hip = new THREE.Group();
  hip.position.set(side * TSTANCE.stance, 0, 0);
  hip.rotation.y = -side * 0.14;                 // 腳尖外八，比 LANCER-2 再開一階
  hip.add(joint(0.34, [0, 0, 0], true));

  var thigh = new THREE.Group(); thigh.userData.bone = 1; hip.add(thigh);
  thigh.add(bevel(MAT_P.dark, cfg.tw * 0.90, 0.24, cfg.tw * 0.88, [0, -0.12, 0]));
  thigh.add(bevel(MAT_P.dark, cfg.tw, 0.28, cfg.tw * 0.98, [0, -0.34, 0]));          // 最鼓
  thigh.add(bevel(MAT_P.dark, cfg.tw * 0.74, 0.24, cfg.tw * 0.74, [0, -0.58, 0]));
  thigh.add(plate(MAT_P.armor, cfg.tw * 1.16, 0.44, 0.56, [0, -0.28, cfg.tw * 0.56], -0.16));
  thigh.add(seam(cfg.tw * 1.04, 0.05, 0.10, [0, -0.48, cfg.tw * 0.60], -0.16));
  thigh.add(rib(MAT_P.armor, 0.09, 0.54, 0.09, [side * cfg.tw * 0.58, -0.32, cfg.tw * 0.26], -0.10));
  thigh.add(ram([cfg.tw * 0.48, -0.52, -cfg.tw * 0.48], 0.50, 0.12, 0.10, [0.16, 0, 0]));
  thigh.add(ram([-cfg.tw * 0.48, -0.52, -cfg.tw * 0.48], 0.50, 0.12, 0.10, [0.16, 0, 0]));

  var knee = new THREE.Group(); knee.position.set(0, -0.68, 0); thigh.add(knee);
  knee.add(joint(0.30, [0, 0, 0], true));
  knee.add(plate(MAT_P.armor, cfg.sw * 1.10, 0.36, 0.48, [0, 0.02, -cfg.sw * 0.62], 0.20));
  knee.add(plate(MAT_P.armor, cfg.sw * 0.94, 0.30, 0.30, [0, -0.04, cfg.sw * 0.60], -0.24));  // 前護膝

  var shin = new THREE.Group(); shin.userData.bone = 1; knee.add(shin);
  shin.add(bevel(MAT_P.dark, cfg.sw, 0.38, cfg.sw * 1.06, [0, -0.18, 0]));           // 腓腸
  shin.add(bevel(MAT_P.dark, cfg.sw * 0.70, 0.30, cfg.sw * 0.72, [0, -0.50, 0]));
  shin.add(plate(MAT_P.armor, cfg.sw * 1.12, 0.46, 0.54, [0, -0.20, cfg.sw * 0.54], -0.12));
  shin.add(rib(MAT_P.armor, 0.09, 0.52, 0.09, [0, -0.22, cfg.sw * 0.64], -0.12));
  if (cfg.hyd) {
    shin.add(ram([cfg.sw * 0.52, -0.28, -cfg.sw * 0.42], 0.54, 0.12, 0.10));
    shin.add(ram([-cfg.sw * 0.52, -0.28, -cfg.sw * 0.42], 0.54, 0.12, 0.10));
  }

  var ankle = new THREE.Group(); ankle.position.set(0, -0.66, 0); shin.add(ankle);
  ankle.add(joint(0.23, [0, 0, 0]));

  var foot = new THREE.Group(); foot.userData.bone = 1; ankle.add(foot);
  foot.add(mesh(G.box, MAT_P.trim, [cfg.fw, 0.18, cfg.fl], [0, -0.13, cfg.fl * 0.08]));
  foot.add(plate(MAT_P.armor, cfg.fw * 0.92, 0.16, cfg.fl * 0.44, [0, -0.02, cfg.fl * 0.26], -0.12));
  foot.add(rib(MAT_P.armor, cfg.fw * 0.82, 0.08, 0.08, [0, 0.06, cfg.fl * 0.44], -0.12));
  foot.add(bevel(MAT_P.dark, cfg.fw * 0.80, 0.24, 0.34, [0, -0.06, -cfg.fl * 0.34]));   // 後跟（配重）
  /* 前後各一塊抓地爪。**後爪是這台獨有的** —— 開砲的後座往後推，
     腳跟要有東西咬住地面，不然重砲讀起來像在滑。 */
  foot.add(mesh(G.box, MAT_P.trim, [cfg.fw * 0.36, 0.14, 0.22], [side * cfg.fw * 0.30, -0.18, cfg.fl * 0.36]));
  foot.add(mesh(G.box, MAT_P.trim, [cfg.fw * 0.30, 0.14, 0.20], [0, -0.18, -cfg.fl * 0.40]));
  return { root: hip, thigh: thigh, shin: shin, foot: foot, side: side };
}

export function titanCfg(shape) {
  return shape === 'thr-ring' ? { tw: 0.70, sw: 0.60, fw: 0.84, fl: 0.98, hyd: false }
    : shape === 'thr-heavy' ? { tw: 0.88, sw: 0.76, fw: 1.02, fl: 1.14, hyd: true }
      : { tw: 0.78, sw: 0.68, fw: 0.94, fl: 1.06, hyd: true };
}

export function buildTitanLegs(shape, P?) {
  P = P || { glow: coreGlow('core-std') };
  var g = new THREE.Group();
  mark(g, shape, ['thr-ring', 'thr-heavy', 'thr-twin']);
  var cfg = titanCfg(shape);

  // 骨盆：寬、厚、四片大裙甲。這是全機第二寬的地方（僅次於肩）
  var pel = new THREE.Group(); pel.userData.bone = 1;
  pel.position.y = -0.06;
  g.add(pel);
  pel.add(bevel(MAT_P.dark, 1.52, 0.50, 1.10, [0, 0.04, 0]));
  pel.add(plate(MAT_P.armor, 0.40, 0.72, 0.98, [0.88, -0.06, 0], 0, -0.18, -0.14));
  pel.add(plate(MAT_P.armor, 0.40, 0.72, 0.98, [-0.88, -0.06, 0], 0, 0.18, 0.14));
  /* 前裙甲刻意做窄（0.86 對骨盆的 1.52）：實拍第一輪它把兩條大腿整個
     蓋住，正面剪影的下半身讀成一個箱子。裙甲要露出腿。 */
  pel.add(plate(MAT_P.armor, 0.86, 0.40, 0.24, [0, -0.30, 0.50], 0.36));             // 前裙甲
  pel.add(plate(MAT_P.armor, 1.28, 0.58, 0.26, [0, -0.18, -0.56], -0.30));           // 後裙甲
  pel.add(rib(MAT_P.armor, 0.10, 0.10, 1.04, [0.92, 0.30, 0], 0, -0.18));
  pel.add(rib(MAT_P.armor, 0.10, 0.10, 1.04, [-0.92, 0.30, 0], 0, 0.18));
  pel.add(mesh(G.box, P.glow, [0.30, 0.05, 0.05], [0, -0.32, 0.62]));

  var L = stompLeg(1, cfg); g.add(L.root);
  var R = stompLeg(-1, cfg); g.add(R.root);
  g.userData.rig = { pelvis: pel, legs: [L, R], cfg: cfg };
  return g;
}

/* 背部：彈艙 + 兩具粗噴口。CHASSIS-0 的背包是「滯空用」、LANCER-2 是
   「姿勢控制」，這台是**彈藥**：背面一排朝上的投射槽（大招那一圈榴彈
   從這裡出去），噴口只有兩具但口徑最大 —— 這台飛得慢但燃料多，
   數值上的 `thrustMax 150 / thrustRise 6.2` 讀得出來。
   `nozzles` 給特效層掛火焰：[x, y, z, 口徑, 傾角]。 */
export function buildTitanBack(shape, P?) {
  P = P || { glow: coreGlow('core-std') };
  var g = new THREE.Group();
  mark(g, shape, ['thr-ring', 'thr-heavy', 'thr-twin']);
  g.userData.nozzles =
    shape === 'thr-ring' ? [[0.42, -0.14, -0.50, 0.40, 0.18], [-0.42, -0.14, -0.50, 0.40, 0.18]]
      : shape === 'thr-heavy' ? [[0.54, -0.24, -0.56, 0.42, 0.30], [-0.54, -0.24, -0.56, 0.42, 0.30],
      [0, -0.40, -0.48, 0.34, 0.48]]
        : [[0.48, -0.20, -0.52, 0.38, 0.26], [-0.48, -0.20, -0.52, 0.38, 0.26]];
  g.userData.vents = [[0.68, 0.36, -0.16], [-0.68, 0.36, -0.16]];

  g.add(bevel(MAT_P.dark, 1.34, 0.64, 0.46, [0, 0.12, -0.06]));                    // 背包本體（大）
  g.add(plate(MAT_P.armor, 1.38, 0.22, 0.48, [0, 0.48, -0.08], -0.24));
  g.add(rib(MAT_P.armor, 1.40, 0.09, 0.09, [0, 0.60, 0.12], -0.24));
  /* 分裂彈的投射槽：背面上緣一排朝上的短管。大招（`sim/weapons-titan.ts`
     的 `fireRingBurst`）是「以自己為圓心丟出一圈」——
     彈從哪裡出去要在機體上看得到，不然那一圈是憑空長出來的。 */
  for (var i = 0; i < 5; i++)
    g.add(mesh(G.cyl, MAT_P.trim, [0.16, 0.30, 0.16], [(i - 2) * 0.26, 0.56, -0.16], [-0.30, 0, 0]));
  g.add(seam(1.26, 0.05, 0.40, [0, 0.30, -0.06]));

  if (shape === 'thr-ring') {
    g.add(mesh(G.tor, MAT_P.armor, [0.92, 0.92, 0.28], [0.44, -0.10, -0.34], [0.20, 0, 0]));
    g.add(mesh(G.tor, MAT_P.armor, [0.92, 0.92, 0.28], [-0.44, -0.10, -0.34], [0.20, 0, 0]));
    g.add(mesh(G.tor, P.glow, [0.66, 0.66, 0.20], [0.44, -0.10, -0.34], [0.20, 0, 0]));
    g.add(mesh(G.tor, P.glow, [0.66, 0.66, 0.20], [-0.44, -0.10, -0.34], [0.20, 0, 0]));
  } else if (shape === 'thr-heavy') {
    g.add(bevel(MAT_P.dark, 0.50, 0.50, 0.48, [0.54, -0.16, -0.36], [0.32, 0, 0]));
    g.add(bevel(MAT_P.dark, 0.50, 0.50, 0.48, [-0.54, -0.16, -0.36], [0.32, 0, 0]));
    g.add(bevel(MAT_P.dark, 0.40, 0.42, 0.40, [0, -0.30, -0.30], [0.50, 0, 0]));
    g.add(mesh(G.cone, P.glow, [0.34, 0.34, 0.34], [0.54, -0.30, -0.48], [-Math.PI / 2 + 0.32, 0, 0]));
    g.add(mesh(G.cone, P.glow, [0.34, 0.34, 0.34], [-0.54, -0.30, -0.48], [-Math.PI / 2 + 0.32, 0, 0]));
    g.add(mesh(G.box, MAT_P.trim, [0.32, 0.52, 0.34], [0.82, 0.20, -0.12]));
    g.add(mesh(G.box, MAT_P.trim, [0.32, 0.52, 0.34], [-0.82, 0.20, -0.12]));
  } else {
    g.add(bevel(MAT_P.dark, 0.46, 0.52, 0.44, [0.48, -0.14, -0.32], [0.28, 0, 0]));
    g.add(bevel(MAT_P.dark, 0.46, 0.52, 0.44, [-0.48, -0.14, -0.32], [0.28, 0, 0]));
    g.add(mesh(G.box, P.glow, [0.30, 0.30, 0.06], [0.48, -0.32, -0.46], [0.28, 0, 0]));
    g.add(mesh(G.box, P.glow, [0.30, 0.30, 0.06], [-0.48, -0.32, -0.46], [0.28, 0, 0]));
    g.add(plate(MAT_P.armor, 0.20, 0.44, 0.38, [0.76, 0.14, -0.06], 0, 0, -0.30));  // 側鰭（只一邊）
  }
  return g;
}
